var _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 60,
    height: 16,
    rx: 8,
    stroke: "#FFA1A1",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 18,
    rx: 9,
    fill: "#FFA1A1"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjIiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCA2MiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjYwIiBoZWlnaHQ9IjE2IiByeD0iOCIgc3Ryb2tlPSIjRkZBMUExIiBzdHJva2Utd2lkdGg9IjIiLz4KPHJlY3Qgd2lkdGg9IjMzIiBoZWlnaHQ9IjE4IiByeD0iOSIgZmlsbD0iI0ZGQTFBMSIvPgo8L3N2Zz4K";
export { SvgLeft as ReactComponent };